<template>
  <div
    >
    <div class="company-mail-endings-details-ending-line">
      <div class="mr-2 d-flex">
        <div>Ending: @</div>
        <input
          class="company-mail-endings-details-input"
          ref="bemail-input"
          v-if="is_edit"
          :value="bemail.value"
          >
        <div v-else>
          {{bemail.hostname}}.{{bemail.domain}}
        </div>
      </div>
      <template v-if="is_edit">
        <v-btn icon class="green mr-2" small
          @click="updateUObject({
              url: [
                {businesses: business.id},
                {bemails: bemail.id}
              ],
              update: {
                value: $refs['bemail-input'].value
              }
            }).then(() => {
              is_edit = false;
              })"
          >
          <v-icon>done</v-icon>
        </v-btn>
        <v-btn icon small @click="is_edit = false">
          <v-icon>cancel</v-icon>
        </v-btn>
      </template>
    </div>
    <div>Created: {{bemail.created}}</div>
    <div>Edited: {{bemail.updated}}</div>
    <div class="company-mail-endings-details-buttons mt-2">
      <!-- <v-btn
        @click="is_edit = true"
        >
        edit
      </v-btn> -->
      <v-btn
        color="red"
        :disabled="is_edit"
        v-click-outside="deleteshurefalse"
        @click="delete_shure?
        deleteUObject({
            url: [
              {businesses: business.id},
              {bemails: bemail.id}
            ],
          }).then(() => {
            $router.push({name: 'CompanyEmailEndings'});
            delete_shure = false;
            })
            :
            delete_shure = true;
            "
        >
        {{delete_shure?'shure?':'delete'}}
      </v-btn>
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  export default {
    props: [],
    data: () => ({
      is_edit: false,
      delete_shure: false,
    }),
    computed: {
      bemail() {
        return this.$store.state.Ultra.bemails[this.$route.params.email_endings_id];
      },
      business() {
        let current_user = this.$store.getters['Auth/getUser'];
        return this.$store.state.Ultra.businesses[current_user.business.id];
      }
    },
    methods: {
      ...mapActions('Ultra', [
        'updateUObject',
        'deleteUObject'
      ]),
      deleteshurefalse() {
        this.delete_shure = false;
      }
    }
  }
</script>
<style>
  .company-mail-endings-details-ending-line {
    display: flex;
    align-items: center;
  }
  .company-mail-endings-details-buttons {
    display: flex;
  }
  .company-mail-endings-details-input {
    outline: 1px solid white;
    width: 300px;
  }
</style>
